import { LinkedinRequests  } from "domain/entities/linkedinrequests";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface LinkedinRequestsState {
  selectedRequest: LinkedinRequests | null;
  setSelectedRequest: (item: LinkedinRequests | null) => void;
  resetSelectedRequest: () => void;
}

export const useLinkedinRequestsSelectedStore =
  create<LinkedinRequestsState>()(
    devtools(
      (set) => ({
        selectedRequest: null,

        setSelectedRequest: (item) =>
          set({ selectedRequest: item }),

        resetSelectedRequest: () =>
          set({ selectedRequest: null }),
      }),
      { name: "LinkedinRequestsSelected" }
    )
  );
